import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdatesSection() {
  const chaptersPerColumn = Math.ceil(latestUpdates.length / 2);
  const leftColumn = latestUpdates.slice(0, chaptersPerColumn);
  const rightColumn = latestUpdates.slice(chaptersPerColumn);

  return (
    <section className="flex flex-col lg:flex-row">
      {/* Left: Image */}
      <div className="lg:w-1/2 relative bg-secondary-50 min-h-[400px] lg:min-h-[600px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20warm%20amber%20and%20cream%20color%20palette%20flowing%20organic%20shapes%20soft%20gradients%20minimal%20design%20Korean%20aesthetic%20peaceful%20reading%20atmosphere%20subtle%20textures%20vertical%20orientation&width=900&height=1200&seq=latest-bg&orientation=portrait"
          alt="最新更新"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-secondary-50/20"></div>
        <div className="absolute top-8 left-8 md:left-12">
          <span className="text-xs text-foreground-500 font-medium uppercase tracking-wider">
            实时同步
          </span>
        </div>
        <div className="absolute bottom-8 left-8 md:bottom-12 md:left-12">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 font-heading leading-none">
            最新
          </h2>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 font-heading leading-none mt-1">
            更新
          </h2>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 font-heading leading-none mt-1">
            速递
          </h2>
        </div>
      </div>

      {/* Right: Updates List */}
      <div className="lg:w-1/2 bg-background-50 py-12 md:py-20 px-6 md:px-12 flex flex-col justify-center">
        <div className="max-w-md mx-auto w-full">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3 text-center lg:text-left">
            最新章节
          </h2>
          <p className="text-sm text-foreground-500 mb-8 text-center lg:text-left">
            每日同步韩国最新更新，精彩不错过
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
            {/* Left Column */}
            <div className="space-y-3">
              {leftColumn.map((item) => (
                <Link
                  key={item.id}
                  to={`/comic/${item.comicId}`}
                  className="block p-3 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer group"
                >
                  <p className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                    {item.comicTitle}
                  </p>
                  <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">
                    {item.chapterTitle}
                  </p>
                  <p className="text-xs text-foreground-400 mt-1.5">{item.updatedAt}</p>
                </Link>
              ))}
            </div>

            {/* Right Column */}
            <div className="space-y-3">
              {rightColumn.map((item) => (
                <Link
                  key={item.id}
                  to={`/comic/${item.comicId}`}
                  className="block p-3 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer group"
                >
                  <p className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                    {item.comicTitle}
                  </p>
                  <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">
                    {item.chapterTitle}
                  </p>
                  <p className="text-xs text-foreground-400 mt-1.5">{item.updatedAt}</p>
                </Link>
              ))}
            </div>
          </div>

          <div className="text-center lg:text-left">
            <Link
              to="/category/completed"
              className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部更新
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}